import styled from "@emotion/styled";
import { Button } from "@xometry/xometry_loft";
import theme from "../../styles/theme";

export const EntryBase = styled.div`
  border-bottom: 1px solid ${theme.colors.darkBlues[10]};
  padding: 1rem 0;
`;

export const HeaderBase = styled.div<{ isOpen: boolean }>`
  display: flex;
  color: ${theme.colors.darkBlues[75]};
  padding: 12px 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.35s;
`;

export const HeaderText = styled.h3`
  flex: 1;
  font-size: ${theme.fontSizes[3]};
  margin: 0;
`;

export const Arrow = styled.i<{ isOpen: boolean }>`
  height: fit-content;
  line-height: 24px;
  transition: all 0.35s;
  transform: ${(props) => (props.isOpen ? `rotate(-180deg)` : ``)};
`;

export const Content = styled.div<{
  isOpen: boolean;
  contentHeight: number | undefined;
}>`
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  height: ${(props) =>
    props.isOpen ? props.contentHeight && props.contentHeight + 24 : `0`}px;
  transition: all 0.25s;
  visibility: ${(props) =>
    props.isOpen && props.contentHeight && props.contentHeight > 0
      ? "visible"
      : `hidden`};

  .four-column-list {
    ul {
      columns: 2;
      -webkit-columns: 2;
      -moz-columns: 2;
      column-gap: 2rem;
      list-style: none;
      padding-left: 0;

      ${theme.largerThan.lg} {
        columns: 4;
        -webkit-columns: 4;
        -moz-columns: 4;
      }

      li {
        margin-bottom: 1rem;
        font-size: ${theme.fontSizes[1]};
        color: ${theme.colors.darkBlues[75]};

        strong {
          font-size: ${theme.fontSizes[2]};
          color: ${theme.colors.darkBlues[90]};
        }
      }
    }

    p.paragraph {
      font-size: ${theme.fontSizes[1]};
    }
  }
`;

export const HelpCenterContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HelpCenterText = styled.div`
  font-size: 14px;
  line-height: 20px;

  ${theme.largerThan.md} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const HelpCenterURL = styled.a`
  margin-bottom: 4px;
  color: ${theme.colors.darkBlues[75]};
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 4px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const HelpCenterButton = styled(Button)`
  width: fit-content;
`;
